// @flow

import * as React from 'react';
import type {MarkdocTagSchema} from 'markdoc/types';
import {ButtonLink} from 'sail/Button';

type MarkdocTagReferenceProps = {|
  tag: MarkdocTagSchema,
  tagName: string,
  children: React.Node,
|};

export const MarkdocTagReference = ({
  tag,
  tagName,
  children,
}: MarkdocTagReferenceProps) => (
  <React.Fragment>
    <ButtonLink
      href={`/docs/markdoc/tags/${tagName}`}
      color="blue"
      icon="arrowRight"
      size="large"
      label="Learn more"
    />
    {tag.description && <p>{tag.description}</p>}
    {children}
  </React.Fragment>
);
